module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/key-metric-task-c554d0c696d8f3add03f7b4a4d9e1434.svg";